import React, { Component } from "react";
import {
  Accordion,
  Breadcrumb,
  Button,
  Container,
  Divider,
  Icon,
  Header,
  Form,
  Grid,
  List,
  Menu,
  Message,
  Modal,
  Segment
} from "semantic-ui-react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { Link } from "react-router-dom";
import { groupBy, orderBy } from "lodash";
import { translate } from "react-i18next";
import * as ROUTES from "../../../routes";
import update from "immutability-helper";
import moment from "moment";
import numeral from "numeral";
import { AutoSizer } from "react-virtualized";
import SubNavigationBar from "../../navigation/SubNavigationBar";

const DEPORTE_TENIS = 1;
const DEPORTE_PADDLE = 2;

const TURNO_MANIANA = "D";
const TURNO_TARDE = "T";
const TURNO_NOCHE = "N";

const INITIAL_STATE = {
  deporte: "",
  fecha: "",
  turno: "",
  disponibilidad: {
    loading: false,
    data: [],
    error: null,
    success: ""
  },
  hora: 0,
  confirmReservationModal: {
    open: false,
    loading: false,
    turno: null
  },
  saldo: {
    loading: false,
    data: 0,
    error: null
  }
};

class NewReservationView extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;

    this.constants = {
      minDate: moment().format("YYYY-MM-DD"),
      maxDate: moment()
        .add(1, "years")
        .format("YYYY-MM-DD")
    };

    this.DisponibilidadService = props.services.feathers.service(
      "api/disponibilidad"
    );
    this.SaldoService = props.services.feathers.service("api/saldo");
    this.ReservaService = props.services.feathers.service("api/reservations");
  }

  setDeporte = (e, input) => {
    this.setState({
      deporte: input.name,
      fecha: "",
      turno: "",
      disponibilidad: {
        loading: false,
        data: [],
        error: null
      },
      hora: 0
    });
  };

  setFecha = e => {
    this.setState({
      fecha: e.target.value,
      turno: "",
      disponibilidad: {
        loading: false,
        data: [],
        error: null
      },
      hora: 0
    });
  };

  setTurno = (e, input) => {
    this.setState(
      {
        turno: input.name,
        disponibilidad: {
          loading: false,
          data: [],
          error: null
        },
        hora: 0
      },
      () => {
        this.cargarDisponibilidad();
      }
    );
  };

  setHora = (e, input) => {
    this.setState({
      hora: input.index
    });
  };

  cargarDisponibilidad = () => {
    let { deporte, fecha, turno } = this.state;

    this.setState(
      update(this.state, {
        disponibilidad: {
          $set: {
            loading: true,
            data: [],
            error: null
          }
        }
      })
    );

    this.DisponibilidadService.find({
      query: {
        deporte,
        fecha,
        turno
      }
    })
      .then(disponibilidad => {
        this.setState(
          update(this.state, {
            disponibilidad: {
              $set: {
                loading: false,
                data: disponibilidad.data,
                error: null
              }
            }
          })
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            disponibilidad: {
              $set: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  getSaldo = () => {
    let { authentication } = this.props;

    this.setState(
      update(this.state, {
        saldo: {
          $merge: {
            loading: true,
            data: 0
          }
        }
      })
    );

    this.SaldoService.get(authentication.user.SocioId)
      .then(response => {
        this.setState(
          update(this.state, {
            saldo: {
              $merge: {
                loading: false,
                data: numeral(response.monto).format("$0,0.00")
              }
            }
          })
        );
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            saldo: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  openConfirmReservationModal = (e, input) => {
    this.setState(
      update(this.state, {
        confirmReservationModal: {
          $merge: {
            open: true,
            turno: input.name
          }
        }
      }),
      () => {
        this.getSaldo();
      }
    );
  };

  dismissConfirmReservationModal = e => {
    this.setState(
      update(this.state, {
        confirmReservationModal: {
          $merge: {
            open: false,
            error: null
          }
        }
      })
    );
  };

  submitReserva = e => {
    this.setState(
      update(this.state, {
        confirmReservationModal: {
          $merge: {
            loading: true,
            error: null
          }
        }
      })
    );

    let {
      deporte,
      fecha,
      hora,
      confirmReservationModal: { turno }
    } = this.state;

    this.ReservaService.create({
      deporte,
      fecha,
      turno,
      hora,
      turno
    })
      .then(response => {
        this.props.navigate(ROUTES.RESERVATIONS + "?success=true");
      })
      .catch(error => {
        this.setState(
          update(this.state, {
            confirmReservationModal: {
              $merge: {
                loading: false,
                error
              }
            }
          })
        );
      });
  };

  static mapDispatchToProps(dispatch) {
    return {
      dispatch,
      navigate: path => dispatch(push(path))
    };
  }

  static mapStateToProps(state) {
    return {
      authentication: state.authentication.toJS()
    };
  }

  render() {
    const { t, authentication } = this.props;
    const userRoles = authentication && authentication.user && authentication.user.roles
      ? authentication.user.roles
      : [];
    const {
      deporte,
      disponibilidad,
      hora,
      fecha,
      turno,
      confirmReservationModal,
      saldo
    } = this.state;
    const { minDate, maxDate } = this.constants;

    let disponibilidadAgrupada = groupBy(disponibilidad.data, "hora");

    return (
      <AutoSizer disableHeight style={{ display: "flex", flex: 1 }}>
        {({ width }) => {
          let Wrapper = Container;
          let style = {};

          if (width < 764) {
            Wrapper = "div";
            style = {
              margin: 0,
              width
            };
          }

          return (
            <Wrapper style={style}>
              {width >= 764 && (
                <SubNavigationBar
                  activeLink="inicio"
                  roles={userRoles}
                />
              )}

              <Segment vertical secondary style={{ padding: 4 }}>
                <Breadcrumb>
                  <Breadcrumb.Section as={Link} link to={"/dashboard"}>
                    Inicio
                  </Breadcrumb.Section>
                  <Breadcrumb.Divider icon="right angle" />
                  <Breadcrumb.Section active>Nueva Reserva</Breadcrumb.Section>
                </Breadcrumb>
              </Segment>

              <Segment vertical>
                <Header as="h3">
                  <Header.Content>
                    NUEVA RESERVA
                    <Header.Subheader>Hacer una nueva reserva</Header.Subheader>
                  </Header.Content>
                </Header>
              </Segment>

              <Segment vertical textAlign="center">
                <Button.Group>
                  <Button
                    active={deporte === DEPORTE_TENIS}
                    name={DEPORTE_TENIS}
                    onClick={this.setDeporte}>
                    TENIS
                  </Button>
                  <Button.Or text="" />
                  <Button
                    active={deporte === DEPORTE_PADDLE}
                    name={DEPORTE_PADDLE}
                    onClick={this.setDeporte}>
                    PADLE
                  </Button>
                </Button.Group>
              </Segment>

              {deporte && (
                <Segment vertical textAlign="center">
                  <Grid centered columns={2}>
                    <Grid.Column>
                      <Form>
                        <Form.Field
                          name="fecha"
                          label="Fecha"
                          type="date"
                          control="input"
                          placeholder="aaaa-mm-dd"
                          min={minDate}
                          max={maxDate}
                          lang="es"
                          onBlur={this.setFecha}
                          onChange={this.setFecha}
                          value={fecha}
                        />
                      </Form>
                    </Grid.Column>
                  </Grid>
                </Segment>
              )}

              {width >= 764
                ? deporte &&
                  fecha && (
                    <Segment vertical textAlign="center">
                      <Button.Group>
                        <Button
                          active={turno === TURNO_MANIANA}
                          name={TURNO_MANIANA}
                          onClick={this.setTurno}>
                          Mañana 8 a 12hs
                        </Button>
                        <Button.Or text="" />
                        <Button
                          active={turno === TURNO_TARDE}
                          name={TURNO_TARDE}
                          onClick={this.setTurno}>
                          Tarde 13 a 18hs
                        </Button>
                        <Button.Or text="" />
                        <Button
                          active={turno === TURNO_NOCHE}
                          name={TURNO_NOCHE}
                          onClick={this.setTurno}>
                          Noche 19 a 23hs
                        </Button>
                      </Button.Group>
                    </Segment>
                  )
                : deporte &&
                  fecha && (
                    <Segment vertical textAlign="center">
                      <Button.Group>
                        <Button
                          active={turno === TURNO_MANIANA}
                          name={TURNO_MANIANA}
                          onClick={this.setTurno}>
                          Mañana
                        </Button>
                        <Button.Or text="" />
                        <Button
                          active={turno === TURNO_TARDE}
                          name={TURNO_TARDE}
                          onClick={this.setTurno}>
                          Tarde
                        </Button>
                        <Button.Or text="" />
                        <Button
                          active={turno === TURNO_NOCHE}
                          name={TURNO_NOCHE}
                          onClick={this.setTurno}>
                          Noche
                        </Button>
                      </Button.Group>
                    </Segment>
                  )}

              {turno && (
                <Segment vertical>
                  {disponibilidad.loading ? (
                    <div>Cargando disponibilidad</div>
                  ) : disponibilidad.error ? (
                    <div>error</div>
                  ) : (
                    <Accordion fluid>
                      {Object.keys(disponibilidadAgrupada).map(
                        (group, index) => {
                          let turnosDisponibles = orderBy(
                            disponibilidadAgrupada[group],
                            ["court"],
                            ["asc"]
                          );

                          return [
                            <Accordion.Title
                              key={index + 1}
                              active={hora === Number(group)}
                              index={Number(group)}
                              onClick={this.setHora}>
                              <Icon name="dropdown" />
                              {group}:00hs
                            </Accordion.Title>,
                            <Accordion.Content
                              key={-(index + 1)}
                              active={hora === Number(group)}>
                              <List horizontal={width >= 764}>
                                {turnosDisponibles.map((turno, index) => {
                                  return (
                                    <List.Item key={index}>
                                      <List.Content>
                                        <Button
                                          fluid={width < 764}
                                          name={turno}
                                          content={`Court ${turno.court + 1}`}
                                          onClick={
                                            this.openConfirmReservationModal
                                          }
                                        />
                                      </List.Content>
                                    </List.Item>
                                  );
                                })}
                              </List>
                            </Accordion.Content>
                          ];
                        }
                      )}
                    </Accordion>
                  )}
                </Segment>
              )}
              <Modal
                open={confirmReservationModal.open}
                closeOnDimmerClick={false}
                onClose={this.dismissConfirmReservationModal}
                size="small">
                <Modal.Header>Confirmar Reserva</Modal.Header>
                <Modal.Content>
                  <Modal.Description>
                    {saldo.loading ? (
                      <div>Chequeando Saldo</div>
                    ) : saldo.error ? (
                      <div>Error al obtener saldo</div>
                    ) : confirmReservationModal.turno ? (
                      <div>
                        <p>Court {confirmReservationModal.turno.court + 1}</p>
                        <p>
                          Dia: {fecha} - Hora: {hora}:00
                        </p>
                        <Divider />
                        <p>
                          <strong>
                            Saldo Actual:{" "}
                            {numeral(saldo.data).format("$0,0.00")}
                          </strong>
                        </p>
                        <p style={{ color: "red" }}>
                          <strong>
                            Costo:{" "}
                            {numeral(
                              confirmReservationModal.turno.monto
                            ).format("$0,0.00")}
                          </strong>
                        </p>
                        <p>
                          <strong>
                            {numeral(saldo.data)
                              .subtract(
                                numeral(
                                  confirmReservationModal.turno.monto
                                ).value()
                              )
                              .value() < 0
                              ? "Saldo Insuficiente"
                              : `Nuevo saldo: ${numeral(saldo.data)
                                  .subtract(
                                    numeral(
                                      confirmReservationModal.turno.monto
                                    ).value()
                                  )
                                  .format("$0,0.00")}`}
                          </strong>
                        </p>
                        {confirmReservationModal.error && (
                          <Segment raised>
                            <Message negative>
                              <Message.Header>Error!</Message.Header>
                              <pre>{confirmReservationModal.error.message}</pre>
                            </Message>
                          </Segment>
                        )}
                        {confirmReservationModal.success && (
                          <Segment raised>
                            <Message positive>
                              <Message.Header>Exito!</Message.Header>
                              <p>Reserva Confirmada!</p>
                            </Message>
                          </Segment>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </Modal.Description>
                </Modal.Content>
                <Modal.Actions>
                  <Button
                    basic
                    negative
                    inverted
                    onClick={this.dismissConfirmReservationModal}
                    disabled={confirmReservationModal.loading}
                    content="Cancelar"
                    icon="remove"
                  />
                  <Button
                    primary
                    onClick={this.submitReserva}
                    disabled={
                      confirmReservationModal.loading ||
                      !confirmReservationModal.turno ||
                      !saldo.data ||
                      numeral(saldo.data)
                        .subtract(
                          numeral(confirmReservationModal.turno.monto).value()
                        )
                        .value() < 0
                    }
                    content={
                      confirmReservationModal.loading
                        ? "Procesando..."
                        : "Aceptar"
                    }
                    icon="checkmark"
                  />
                </Modal.Actions>
              </Modal>
            </Wrapper>
          );
        }}
      </AutoSizer>
    );
  }
}

const i18nEnhancement = translate("translations")(NewReservationView);

export default connect(
  NewReservationView.mapStateToProps,
  NewReservationView.mapDispatchToProps
)(i18nEnhancement);



// WEBPACK FOOTER //
// ./src/components/views/reservations/NewReservationView.jsx